import { api } from 'app/config/apiConfig';
import { GenerateEmailPdfParams } from '../model/types';

export const generateEmailPdfApi = api.injectEndpoints({
  endpoints: (builder) => ({
    generateEmailPdf: builder.mutation<Blob, GenerateEmailPdfParams>({
      query: (body) => ({
        url: '/emails/pdf',
        method: 'POST',
        body,
        responseHandler: async (response): Promise<Blob> => await response.blob(),
      }),
    }),
  }),
});

export const { useGenerateEmailPdfMutation } = generateEmailPdfApi;
